import devolucionesDistributorIds from "../../config/devolucionesDistributorIds.json";
import devolucionesPdvIds from "../../config/devolucionesPdvIds.json";

const environment = process.env.REACT_APP_ENVIRONMENT;

const allowedDistributorIds = Object.values(
  devolucionesDistributorIds[environment] ?? {}
);

// Lista vacía para el entorno = sin filtro por punto de venta.
const allowedPdvIds = Object.values(devolucionesPdvIds[environment] ?? {});

export const canSeeDevoluciones = (pointOfSale = {}) =>
  allowedDistributorIds.includes(Number(pointOfSale.id_distributor)) &&
  (allowedPdvIds.length === 0 || allowedPdvIds.includes(Number(pointOfSale.id)));
